import React, { type FunctionComponent, useState } from 'react'
import { DateWithUTCTooltip } from '../../../common'
import { hasEditUserPermission } from '../../../../services/permission.service'
import { CancelScheduledDeleteDialog } from '../dialogs/CancelScheduledDeleteDialog'
import { DeleteUserDialog } from '../dialogs/DeleteUserDialog'
import { isToday } from 'date-fns'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  userInfo: UserInfoType
}

export const UserDelete: FunctionComponent<Props> = ({ userInfo }) => {
  const { id, scheduledDeleteAt } = userInfo

  const [showCancelScheduledDeleteDialog, setShowCancelScheduledDeleteDialog] = useState(false)
  const [userScheduledDeleteAt, setUserScheduledDeleteAt] = useState<string | null>(scheduledDeleteAt)
  const [showConfirmDeleteUserDialog, setShowConfirmDeleteUserDialog] = useState(false)

  return (
    <>
      <div className={`flex ${userScheduledDeleteAt ? 'justify-between' : 'justify-end'} items-end`}>
        {hasEditUserPermission() &&
          (userScheduledDeleteAt ? (
            <>
              <dl>
                <dt id="scheduledDelete" className="text-gray-600">
                  Scheduled delete
                </dt>
                <dd aria-labelledby="scheduledDelete">
                  {isToday(new Date(userScheduledDeleteAt)) ? (
                    'Today'
                  ) : (
                    <DateWithUTCTooltip date={new Date(userScheduledDeleteAt)} />
                  )}
                </dd>
              </dl>

              {scheduledDeleteAt && !isToday(new Date(scheduledDeleteAt)) && (
                <Button className="px-3 py-1 text-xs" onClick={() => setShowCancelScheduledDeleteDialog(true)}>
                  Cancel
                </Button>
              )}
            </>
          ) : (
            <Button variant="destructive" onClick={() => setShowConfirmDeleteUserDialog(true)}>
              Delete user
            </Button>
          ))}
      </div>

      {showConfirmDeleteUserDialog && (
        <DeleteUserDialog
          userInfo={userInfo}
          onClose={deletionDate => {
            setShowConfirmDeleteUserDialog(false)
            setUserScheduledDeleteAt(deletionDate)
          }}
        />
      )}

      {showCancelScheduledDeleteDialog && (
        <CancelScheduledDeleteDialog
          userId={id}
          scheduledDeleteAt={userScheduledDeleteAt}
          onClose={status => {
            setShowCancelScheduledDeleteDialog(false)

            if (status === 'success') {
              setUserScheduledDeleteAt(null)
            }
          }}
        />
      )}
    </>
  )
}
